import { render, staticRenderFns } from "./TempiDiLavorazione.vue?vue&type=template&id=2292dc58&"
import script from "./TempiDiLavorazione.vue?vue&type=script&lang=js&"
export * from "./TempiDiLavorazione.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports